import { render } from "./BenefitItem.vue?vue&type=template&id=7da8bd9e"
import script from "./BenefitItem.vue?vue&type=script&lang=js"
export * from "./BenefitItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__